export default __webpack_public_path__ + "static/media/1.eb17a801.jpg";